module.exports = __webpack_public_path__ + "static/media/walls.95bc5b3e.png";